import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Avatar, Heading, Text, useModalControl } from '@frontend/design-system';
import { ProviderPhotoUploadModal } from './provider-photo-upload-modal';

interface Props {
  locationId: string;
  providerName?: string;
  providerPhoto?: string;
  onChangeProviderPhoto: (src: string) => void;
}

export const ProviderEditableAvatar = ({ locationId, providerName, providerPhoto, onChangeProviderPhoto }: Props) => {
  const { t } = useTranslation('schedule');
  const providerPhotoModalControl = useModalControl();

  const name = providerName || t('Provider');
  return (
    <section css={photoContainerStyles}>
      <Avatar isUser size='xl' src={providerPhoto} name={name} {...providerPhotoModalControl.triggerProps}>
        <Avatar.BottomIcon>
          <Icon name='plus-small' size={20} color='white' css={avatarPlusIconStyles} style={{ right: 0, bottom: 0 }} />
        </Avatar.BottomIcon>
      </Avatar>
      <div>
        <Heading level={3}>{t('Profile Picture')}</Heading>
        <Text size='small' color='light'>
          {t('Upload a photo for this provider. It will appear in online scheduling and the Weave calendar.')}
        </Text>
      </div>
      <ProviderPhotoUploadModal
        {...providerPhotoModalControl.modalProps}
        locationId={locationId}
        providerName={name}
        providerPhoto={providerPhoto}
        onChangeProviderPhoto={onChangeProviderPhoto}
      />
    </section>
  );
};

const avatarPlusIconStyles = css({
  background: theme.colors.primary50,
  border: `1.5px solid ${theme.colors.white}`,
  padding: theme.spacing(0.25),
});

const photoContainerStyles = css({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(3),
});
